import jwt_decode from 'jwt-decode';

const parseJwt = (token: string): any => {
  try {
    return jwt_decode(token);
  } catch (error) {
    console.log(error);
  }
  return null;
};

export default parseJwt;
